import React from "react";
import { View } from "react-native";
import { StatCard } from "@/components/ui/StatCard";
import { Icon } from "@/components/ui/Icon";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useI18n } from "@/context/I18nContext";

export interface LocalizationStatCardsProps {
  allCount?: number;
  completedCount?: number;
  pendingCount?: number;
}

/**
 * Three stat cards for the Localization tab header:
 *  All Content | Completed Localization | Pending Localization
 *
 * Matches Figma node 13307:55252 / 13307:53378.
 */
export function LocalizationStatCards({
  allCount,
  completedCount,
  pendingCount,
}: LocalizationStatCardsProps) {
  const { t } = useI18n();

  return (
    <View className="flex-row flex-wrap gap-4">
      <StatCard
        title={t("staff.localization.stats.allContent")}
        value={allCount?.toLocaleString() ?? "—"}
        description={t("staff.localization.stats.allContentDesc")}
        iconBgClass="bg-blue-5"
        icon={
          <Icon
            as={MaterialCommunityIcons}
            name="file-multiple-outline"
            size={24}
            className="text-blue-50"
          />
        }
      />
      <StatCard
        title={t("staff.localization.stats.completed")}
        value={completedCount?.toLocaleString() ?? "—"}
        description={t("staff.localization.stats.completedDesc")}
        iconBgClass="bg-green-5"
        icon={
          <Icon
            as={MaterialCommunityIcons}
            name="file-check-outline"
            size={24}
            className="text-green-50"
          />
        }
      />
      <StatCard
        title={t("staff.localization.stats.pending")}
        value={pendingCount?.toLocaleString() ?? "—"}
        description={t("staff.localization.stats.pendingDesc")}
        iconBgClass="bg-orange-5"
        icon={
          <Icon
            as={MaterialCommunityIcons}
            name="file-clock-outline"
            size={24}
            className="text-orange-50"
          />
        }
      />
    </View>
  );
}
